import TaskDialog from '@jimmyboys/liita-ui/dist/components/TaskDialog'
import React from 'react'
import styles from 'assets/styles/theme.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const { tabBarHeight } = styles

const Drawer = ({
	children,
	className,
	dialogId,
	handleClose,
	overrideClasses,
	customHeader,
	backdrop,
}) => {
	const { screenSize } = useGlobal()

	return (
		<TaskDialog
			className={className}
			dialogId={dialogId}
			title={''}
			$closing={false}
			dockable={true}
			scrollable={true}
			icon={''}
			startingPoint='right'
			offsetBottom={
				screenSize === 'small'
					? `${parseInt(tabBarHeight, 10) + 15}px`
					: '20px'
			}
			setDialogDetails={null}
			handleDrawerClose={handleClose}
			overrideClasses={overrideClasses}
			customHeader={customHeader ?? null}
			backdrop={backdrop}
			closeBackdropOnClick={backdrop}
		>
			{children}
		</TaskDialog>
	)
}

export default Drawer
